import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteCreditDispensation(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteCreditDispensation = (creditDispensationId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`credit-dispensations/${creditDispensationId}/`);
  };

  return useMutation(deleteCreditDispensation, {
    onSuccess: () => {
      queryClient.removeQueries({
        queryKey: ['creditDispensations'],
      });
      queryClient.invalidateQueries({
        queryKey: ['athletePackages'],
      });
    },
  });
}
